import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-296f16ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-edit" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-move-folder" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize('folder.settings.popup.title')), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.renameFolder }, {
        icon: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('folder.settings.popup.rename.option')) + " ", 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (!_ctx.disableMove)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 0,
            onClick: _ctx.openMovePopUp
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('folder.settings.popup.move.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.deleteFolder }, {
        icon: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('folder.settings.popup.delete.option')) + " ", 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openInfoPopUp }, {
        icon: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('folder.settings.popup.info.option')) + " ", 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onHide"]))
}